export const Cost = 0;
export const ShipmentEdit = 1;